import { Box, TableCell, TableRow, useTheme } from "@mui/material"
import { getPricingStatusOptions } from "../../../shared/options"
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { rdsMeeting_Dto } from "../../../../interfaces/dtos/rdsMeeting";
import { useAppSelector } from "../../../../redux/hooks";
import { scheduleState } from "../../../../redux/schedule/scheduleSlice";
import { rdsState } from "../../../../redux/rds/rdsSlice";

export interface ScheduleMeetingsItemProps {
    meeting: rdsMeeting_Dto;
    selected: boolean;
    onSelected: (meetingId: number) => void;
}

export const ScheduleMeetingsItem = ({
    meeting, selected, onSelected
}: ScheduleMeetingsItemProps) => {

    const rds = useAppSelector(rdsState);
    const schedule = useAppSelector(scheduleState);
    const theme = useTheme();
    const pricingStatusOptions = getPricingStatusOptions(theme);
    
    const rdsEvents = rds.rdsEvents.filter((e) => e.meetingId === meeting.id);
    const rdsEventIds = rdsEvents.map((e) => e.id);
    const scheduleEvents = schedule.scheduleEvents.filter((e) => rdsEventIds.some((r) => r === e.eventId));

    const getPricingStatusCode = () => {
        if (rdsEvents.length === 0) {
            return ''
        }
        const eventsPriced = scheduleEvents.filter((e) => e.pricingStatusCode && e.pricingStatusCode === 'P');
        if (eventsPriced.length === rdsEvents.length) {
            return 'AP';
        }
        if (eventsPriced.length === 0) {
            return 'NP';
        }
        return 'PP';
    }

    const pricingStatusOption = pricingStatusOptions.find((o) => o.value === getPricingStatusCode());
    // TODO: non MVP for now
    //const pricingStatusDescription = pricingStatusOption ? pricingStatusOption.description : '';

    const track = rds.rdsTracks.find((t) => t.id === meeting.trackId);
    const country = track ? track.country : '';

    return (
        <TableRow
            id={`schedule-meeting-${meeting.id}`}
            hover
            selected={selected}
            sx={{ cursor: 'pointer' }}
            onClick={() => onSelected(meeting.id)}
        >
            <TableCell>
                {selected &&
                    <Box sx={{ position: 'relative' }}>
                        <Box sx={{ position: 'absolute', top: '-10px' }}>
                            <CheckBoxIcon color="primary" sx={{ height: '20px', width: '20px' }} />
                        </Box>
                    </Box>
                }
            </TableCell>
            <TableCell>{meeting.categoryCode}</TableCell>
            <TableCell>{meeting.description}</TableCell>
            <TableCell>{rdsEvents.length > 0 ? rdsEvents.length : ''}</TableCell>
            <TableCell>{country}</TableCell>
            <TableCell sx={{ color: pricingStatusOption?.colour }}>
                {/* // TODO: Non MVP for now */}
                {/* {pricingStatusDescription} */}
            </TableCell>
        </TableRow>
    )
}
